import { convertTime } from '../utils/convert-timestamp';
import { formatMoney, getOrderNumberFromdate } from '../utils/constant';
import { formatDate } from '../utils/date-formatter';

export const STATUS_COLUMN_IDS = ['order_status', 'product_status'];
export const IMAGE_COLUMN_IDS = ['icon', 'image_url', 'profile_image'];

export function getStatusChipLabel(row, columnId) {
  if (row.order_status && columnId === 'order_status') {
    if (row.order_status === 'NEEDTOCALLAGAIN') {
      return 'CALL AGAIN';
    }
    if (row.order_status === 'RECEIVED') {
      return 'PENDING';
    }
    return row.order_status;
  }
  return row.status;
}

export function getStatusChipColor(row, columnId) {
  const isOrderStatus = columnId === 'order_status';

  if (
    row.status === 'COMPLETED' ||
    (isOrderStatus && (row.order_status === 'DELIVERED' || row.order_status === 'CONFIRMED')) ||
    row.status === 'AVAILABLE'
  ) {
    return 'success';
  }
  if (isOrderStatus && (row.order_status === 'CANCELLED' || row.order_status === 'RECEIVED')) {
    return 'error';
  }
  if (isOrderStatus && row.order_status === 'NEEDTOCALLAGAIN') {
    return 'default';
  }
  return 'warning';
}

export function getPaymentStatusLabel(row) {
  const total = row.product_amount + row.shipping_cost;

  if (row.payment_status === 'COMPLETED' || (row.total_completed_amount > 0 && row.total_completed_amount >= total)) {
    return 'COMPLETED';
  }
  if (row.total_completed_amount > 0) {
    return 'INCOMPLETE';
  }
  return row.payment_status;
}

export function getPaymentStatusColor(row) {
  if (row.status === 'COMPLETED' || row.payment_status === 'COMPLETED') {
    return 'success';
  }
  if (row.payment_status === 'PENDING') {
    return 'error';
  }
  return 'default';
}

export function isSwitchOn(row) {
  return row.is_published === 'YES' || row.status === 'ACTIVE' || row.status === 'AVAILABLE';
}

export function getRowPersonName(row) {
  if (row.first_name) {
    return `${row.first_name} ${row.last_name}`;
  }
  if (row.firstName) {
    return `${row.firstName} ${row.secondName}`;
  }
  return '';
}

export function getRowImage(row, columnId) {
  if (columnId === 'profile_image') {
    return row.doc_profile_image || row.profileImage || row.icon;
  }
  return row.icon_url || row.image_url || row.icon;
}

export function getLocationText(row) {
  return [row.region, row.district, row.ward, row.street].filter(Boolean).join(', ');
}

export function getCellText(row, columnId) {
  switch (columnId) {
    case 'name':
      return getRowPersonName(row);
    case 'location':
      return getLocationText(row);
    case 'order_number':
      return `${row.id + getOrderNumberFromdate(row.created_at)}`;
    case 'placed_at':
      return formatDate(row.created_at);
    case 'amount':
      return formatMoney(row.amount);
    case 'notification_interval':
      return convertTime(row[columnId]);
    default:
      return row[columnId];
  }
}
